import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// Public marketing/legal routes that SHOULD be indexed. Everything else
// (dashboard, login, oauth, billing, error/redirect pages, the 404
// catch-all, etc.) is noindexed by default — a whitelist is safer here
// than trying to enumerate every private path.
const PUBLIC_PATHS = new Set([
  "/",
  "/pricing",
  "/faq",
  "/help",
  "/about",
  "/contact",
  "/privacy-policy",
  "/terms-of-service",
  "/refund-policy",
  "/data-deletion",
  "/security",
  "/tabs-guide",
  "/status-guide",
  "/analytics-guide",
  "/discounts-guide",
  "/abandoned-cart-guide",
  "/team-guide",
  "/catalog-guide",
  "/public-catalog-guide",
  "/razorpay-keys-guide",
  "/stripe-keys-guide",
  "/paypal-keys-guide",
  "/shiprocket-tracking-guide",
  "/shippo-tracking-guide",
  "/webhooks-guide",
  "/bulk-image-upload-guide",
  "/referral-guide",
]);

export default function NoIndexGuard() {
  const { pathname } = useLocation();

  // Whitelist approach: only explicitly public routes get indexed.
  // Anything else (dashboard, auth, error/redirect pages, unknown routes)
  // is noindex by default — safer than trying to list every private path.
  const isPublic =
    PUBLIC_PATHS.has(pathname) ||
    pathname === "/blog" ||
    pathname.startsWith("/blog/") ||
    pathname === "/features" ||
    pathname.startsWith("/features/") ||
    pathname === "/compare";

  if (isPublic) return null;

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
